import { AppState } from '@Redux/store';
import { ArsenalArmyState } from '@Stores/index';

export const getArsenalArmyState = (state: AppState): ArsenalArmyState => {
  return state.arsenalArmy;
};
